import React from "react";
import { useNavigate } from 'react-router-dom';


function Projects({name, image, description, url}) {

    const transition = {
        transition: ".3s"
    }
    const history = useNavigate();

    const handleClick = () =>{
        window.scrollTo(0, 0)
        history('/projects' + url);
    }
    
    return (
            <div onClick={handleClick} style={transition} className="max-w-sm w-full rounded-xl shadow-lg hover:bg-black/10 cursor-pointer">
                <div className="h-[16rem] w-full overflow-hidden rounded-t-xl bg-white flex items-center justify-center">
                    <img className="h-full w-full object-contain" src={image} alt={name}/>
                </div>
                    <div className="hidden sm:block  px-6 py-4 ">
                        <div className="font-bold text-xl mb-4 lg:w-full text-center">{name}</div>
                        <p className="text-gray-700 text-base hidden sm:hidden md:hidden lg:grid " >
                            {description}
                        </p>
                    </div>
            </div>
    );
}
export default Projects;